import React, { forwardRef, useState } from 'react'
import { CustomModal } from '@components'
import { Box, FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import { useDispatch } from 'react-redux'
import { apiSaveBidOrder } from '@store'
import { showToast } from '@utils'

const Sell = forwardRef(({ handleCloseModal, selectedRow }, ref) => {
    const dispatch = useDispatch()

    const state = {
        uuid: selectedRow?.uuid || "",
        contract: selectedRow?.contract || "",
        owner: selectedRow?.owner || "",
        price: selectedRow?.price || "",
        volume: selectedRow?.quantity || 0,
        buyer: "",
        seller: selectedRow?.owner || "",
        location: selectedRow?.location || "",
        currency: selectedRow?.currency || "",
        ttl: selectedRow?.ttl || "",
        type: "buy",
        option: selectedRow?.option || "",
        step: 0.1,
        minVolume: 0,
        maxVolume: selectedRow?.quantity || 0,
        valid_until: selectedRow?.valid_until || "",
    }

    // Add submitting state
    const [submitting, setSubmitting] = useState(false)

    const handleSell = async (e) => {
        e.preventDefault()
        if (submitting) return;
        setSubmitting(true)
        const resp = await dispatch(apiSaveBidOrder(state))
        if (resp?.meta?.requestStatus === 'fulfilled') {
            showToast('success', 'Contract Sold Successfully')
            handleCloseModal()
        } else if (resp?.meta?.requestStatus === 'rejected') {
            showToast('error', resp?.payload || 'Error Selling Contract')
            setSubmitting(false)
        }
    }

    return (
        <CustomModal
            handleClose={handleCloseModal}
            handleSubmit={handleSell}
            modalTitle={`Sell Contract`}
            modalTitleColor={'#EB6969'}
            buttonText={'Sell'}
            className='modal-button-danger'
            disabled={submitting} // now disabled when submitting is true
            ref={ref}
        >
            <Box className='flex flex-col gap-3'>
                <FormControl>
                    <InputLabel
                        id="contractLabel"
                    >
                        Contract
                    </InputLabel>
                    <OutlinedInput
                        id="contract"
                        label="contract"
                        name='contract'
                        value={selectedRow?.contract}
                        disabled
                    />
                </FormControl>
                <FormControl fullWidth variant="outlined">
                    <InputLabel
                        id="contractLabel"
                        sx={{ bgcolor: '#F5F5F5', p: '0 3px' }}
                    >
                        Volume
                    </InputLabel>
                    <OutlinedInput
                        id="volume"
                        label="Volume"
                        name="quantity"
                        type="number"
                        value={selectedRow?.quantity}
                        inputProps={{ step: 0.01, min: 0 }}
                        required
                        disabled
                        endAdornment={
                            <InputAdornment position="start">
                                MW
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <FormControl>
                    <InputLabel
                        id="priceLabel"
                    >
                        Price
                    </InputLabel>
                    <OutlinedInput
                        id="price"
                        label="price"
                        name='price'
                        value={selectedRow?.price}
                        disabled
                    />
                </FormControl>
                <FormControl>
                    <InputLabel
                        id="sellerLabel"
                    >
                        Seller
                    </InputLabel>
                    <OutlinedInput
                        id="seller"
                        label="seller"
                        name='owner'
                        value={selectedRow?.owner}
                        disabled
                    />
                </FormControl>
                <FormControl>
                    <InputLabel
                        id="locationLabel"
                    >
                        Location
                    </InputLabel>
                    <OutlinedInput
                        id="location"
                        label="location"
                        name='location'
                        value={selectedRow?.location}
                        disabled
                    />
                </FormControl>
                <FormControl>
                    <InputLabel
                        id="currencyLabel"
                    >
                        Currency
                    </InputLabel>
                    <OutlinedInput
                        id="currency"
                        label="currency"
                        name='currency'
                        value={selectedRow?.currency}
                        disabled
                    />
                </FormControl>
                <FormControl>
                    <InputLabel
                        id="validUntilLabel"
                    >
                        Valid Until
                    </InputLabel>
                    <OutlinedInput
                        id="validUntil"
                        label="validUntil"
                        name='valid_until'
                        value={selectedRow?.valid_until}
                        disabled
                    />
                </FormControl>
            </Box>
        </CustomModal>
    )
})

export default Sell